<div class="field">
	<label>Card Number:</label>
	<div class="fields">
		<div class="four wide field" app-field [error]="validation | path: 'amisCardNumber'">
			<div class="ui left icon input">
				<i class="credit card outline icon"></i>
				<input type="text" [(ngModel)]="amisCardModel.amisCardNumber">
			</div>
		</div>
		<div class="field">
			<button class="ui fluid primary button"
				[disabled]="!isValid || !amisCardModel.amisCardNumber"
				(click)="onSubmit()">
				Search
			</button>
		</div>
	</div>
</div>